export default {
  computed: {
    classifications() {
      return this.$store.getters['classification/classifications'];
    },
  },
};
